// src/pages/Profile.js
import React from "react";
import { Box, Typography } from "@mui/material";

function Profile() {
  return (
    <Box sx={{ p: 2, backgroundColor: "#fff", borderRadius: "10px", m: 2 }}>
      <Typography variant="h4">My Profile</Typography>
      <Typography variant="body1">Profile details go here.</Typography>
    </Box>
  );
}

export default Profile;
